<script setup lang="ts">
import { computed } from "vue";

defineOptions({
  name: "VActionRow",
});

/**
 * A bordered row with a statement on the left and its action on the right, as in the Beheren tabs: the connection
 * row ("Actief" with "Openen"), the guest notification row and the red Verwijderen row.
 */
const {
  title = "",
  text = "",
  tone = "default",
} = defineProps<{
  /** Bold first line; omit for a single sentence row. */
  title?: string
  text?: string
  /** `danger` draws the red border of a destructive row. */
  tone?: "default" | "danger"
}>();

defineSlots<{
  default?: () => unknown
  actions?: () => unknown
}>();

const borderClass = computed(() => (tone === "danger" ? "border-red-100 dark:border-red-500/30" : "border-gray-300 dark:border-dark-600"));
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-3 rounded-xl border px-4 py-3.5 text-sm" :class="borderClass">
    <div class="flex min-w-0 flex-1 flex-col gap-0.5">
      <span v-if="title" class="text-[15px] font-medium text-(--text)">{{ title }}</span>
      <span v-if="text || $slots.default" class="leading-normal" :class="title ? 'text-[13px] text-gray-700 dark:text-gray-400' : 'text-(--text)'">
        <slot>{{ text }}</slot>
      </span>
    </div>
    <div v-if="$slots.actions" class="flex shrink-0 items-center gap-2.5">
      <slot name="actions" />
    </div>
  </div>
</template>
